
import VueTimepicker from 'vue2-timepicker';
import TextInput from '../text-input';
import Icon from '../../../../icon';
import { ControlEventType } from '../../enums';
import { TextInputProperty, TextInputType } from '../text-input/enums';
import { InputFillType, InputSlotType } from '../../shared/input/enums';
import { TimePickerProperty } from './enums';
import TimePickerProps from './mixins/TimePickerProps';
import { IconType, IconProperty } from '../../../../icon/enums';
import { StyleSizeType } from '../../../../../styles/enums';
import StyleClassNamesBuilder from '../../../../../styles/helpers/StyleClassNamesBuilder';

const TIMEPICKER_REF = 'vue2-timepicker';
const TEXT_INPUT_REF = 'root-ref';

export default {
  name: 'TimePicker',
  components: {
    Icon,
    TextInput,
    VueTimepicker,
  },
  mixins: [TimePickerProps],
  data() {
    return {
      isFocused: false,
      TEXT_INPUT_REF,
      TIMEPICKER_REF,
      TimePickerProperty,
      TextInputProperty,
      TextInputType,
      IconType,
      IconProperty,
      InputSlotType,
      StyleSizeType,
      ControlEventType,
    };
  },
  computed: {
    timePickerClassNames() {
      return new StyleClassNamesBuilder('time-picker')
        .addColorSchemeConditionClassNames(this[TimePickerProperty.ColorScheme])
        .addConditionClassNames(Object.values(InputFillType), this[TimePickerProperty.FillType])
        .addConditionClassName('focused', this.isFocused)
        .build();
    },
    inputValue() {
      const currentValueDate = this[TimePickerProperty.Value];

      if (!currentValueDate) {
        this.clearTime();
      }

      return currentValueDate || '';
    },
  },
  methods: {
    handleTimePickerChange(time) {
      this.$emit(ControlEventType.Change, time.displayTime);
    },
    getInputRef() {
      return this.$refs[TEXT_INPUT_REF].$el.querySelector('input');
    },
    handleInputClick() {
      if (this[TimePickerProperty.Disabled]) {
        return;
      }

      if (!this.isFocused) {
        this.getInputRef()?.focus();
      }

      this.openPicker();
    },
    handleInputFocus() {
      this.isFocused = true;
      this.$emit(ControlEventType.Focus);
    },
    handleInputBlur() {
      this.isFocused = false;
      this.$emit(ControlEventType.Blur);
    },
    openPicker() {
      this.$refs[TIMEPICKER_REF]?.onFocus();
    },
    clearTime() {
      this.$refs[TIMEPICKER_REF]?.clearTime();
    },
  },
};
